import { SelectDisplayBlock as SelectDisplayBlockType } from '../../types/blueprint'
import { Unanswered } from '../DisplayBlock.style'

import { Tag } from '@/components/shared-components/BUI/Tag'
import { Flexbox } from '@/components/shared-components/Flexbox'

type Props = {
  block: SelectDisplayBlockType
}

export const SelectDisplayBlock: React.FC<Props> = ({ block }) => {
  return (
    <Flexbox flexWrap="wrap" gap="0.5rem">
      {!block.options?.length && <Unanswered />}

      {block.options?.map((option) => (
        <Tag key={option.value} label={option.label} size="small" />
      ))}
    </Flexbox>
  )
}
